module.exports = __webpack_public_path__ + "static/media/user1.9b9ca074.jpeg";